import { breakpointKeys } from 'src/js/modules/element-settings/constants/breakpoints';
import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';
import settingIds from '../../constants/setting-ids';
import { borderTargets } from '../../constants/targets';

const BORDER_ENABLED_VALUE = '1px';

export default [
  {
    scope: settingIds.THIS_COLUMN,
    attribute: targetAttributes.BORDER,
    classes: borderTargets,
    convert: () => ({ [breakpointKeys.DEFAULT]: BORDER_ENABLED_VALUE }),
  },
];

export { BORDER_ENABLED_VALUE };
